import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import type { TopicAction } from '@stores/topic/action';
import { BasePage } from '@components/Base/BasePage';
import styles from './index.module.scss';
import type { BasePageProps } from '../../../../types/base';
import { withRouter } from 'react-router-dom';
import { RouteComponentProps } from 'react-router-dom';
import { BASE_IMG_URL } from '@images/imageUrls';
import TabNav from '@components/tabNav';
import TabFilter from '@components/tabFilter';
import ThreadList from '@components/threadList';
import { formatNumberToWan } from '@utils/formatNumber'
import classNames from 'classnames';
import AvatarList from '@components/avatarList';
import DownloadApp from '@components/downloadApp';
import SidebarTopicList from '@components/sidebarTopicList';
import SidebarUserInfo from '@components/sidebarUserInfo';
import Avatar from '@components/avatar';
import { Carousel } from 'antd';


interface TopicThreadListPCPageProps extends BasePageProps, RouteComponentProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    topic?: TopicAction;
    handleSetState: any
}
interface TopicThreadListPCState {
    loading: boolean;
    error: any
    pageLoaded: any
    // topisDetail: any
    // navList: any
    // filterList: any
    // navCurrentIndex: any
    // filterCurrentIndex: any
    userList: any
    windowWidth: any
    scrollY: any
}
@inject('app', 'site', 'user', 'topic')
@observer
class TopicThreadListPCPage extends BasePage<TopicThreadListPCPageProps, TopicThreadListPCState> {
    state = {
        loading: false,
        error: null,
        pageLoaded: false,
        userList: [],
        windowWidth: 0, // 浏览器宽度
        scrollY: 0, // 滚动高度
    };
    // 防抖定时器
    private resizeTimeout: NodeJS.Timeout | null = null;
    private scrollTimeout: NodeJS.Timeout | null = null;
    async componentDidMount() {
        // 初始化窗口尺寸和滚动位置
        this.updateWindowDimensions();
        this.updateScrollPosition();

        // 添加事件监听
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('scroll', this.handleScroll);

        
        super.componentDidMount();
    }
    componentWillUnmount() {
        // 移除事件监听
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('scroll', this.handleScroll);

        // 清除定时器
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
    }

    // // 类型切换
    // navClick = (item: any) => {
    // }

    // // 筛选切换
    // filterClick = (item: any) => {
    // }


    // 更新窗口尺寸
    updateWindowDimensions = () => {
        this.setState({
            windowWidth: window.innerWidth
        });
    }

    // 更新滚动位置
    updateScrollPosition = () => {
        const scrollY = window.scrollY || document.documentElement.scrollTop;
        this.setState({ scrollY });

        // 检查滚动高度是否超过200px
        if (scrollY > 270) {
        }
    }

    // 防抖处理窗口大小变化
    handleResize = () => {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
            this.updateWindowDimensions();
        }, 100);
    }

    // 防抖处理滚动事件
    handleScroll = () => {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.updateScrollPosition();
        }, 16); // 约60fps
    }

    // 加载下一页数据
    handleLoadMore = () => {
        const { topic } = this.props;
        if (!topic) return;

        const list = topic.listStore.lists['topicThreadList'];
        if (!list) return;

        const currentPage = list.attribs?.currentPage || list.attribs?.page || 1;
        const nextPage = currentPage + 1;
        const pageSize = list.attribs?.pageSize || 20;


        let params: any = {
            "page[number]": nextPage,
            "page[size]": pageSize
        }

        topic.getTopicThreadList(params).then((res: any) => {
        })
    }

    // 帖子列表
    renderThreadList = () => {
        const { topic } = this.props;
        if (!topic || !topic.listStore) return null;
        const list = topic.listStore.lists['topicThreadList'];
        if (!list) return null;
        const flatList = topic.listStore.getList({ namespace: 'topicThreadList' });
        return (
            <div style={{ marginBottom: 16 }}>
                <ThreadList
                    data={flatList}
                    loading={list.loading}
                    hasMore={list.hasMore}
                    onLoadMore={this.handleLoadMore}
                    namespace="topicThreadList"
                    listStore={topic.listStore}
                ></ThreadList>
                {list.loading && <div className={styles.loading}>加载中...</div>}
                {!list.hasMore && !list.loading && <div className={styles.loading}>没有更多了</div>}
                {list.requestError.isError && <div className={styles.loading}>{list.requestError.errorText}</div>}
            </div>
        )
    }

    // 首页左侧侧内容
    readerLeft = () => {
        return (
            <div className={styles.leftContent}>
                {this.renderThreadList()}
            </div>
        );
    }

    // 首页右侧内容
    readerRight = () => {
        let isLogin = false;
        return (
            <div className={styles.rightContent}>
                {/* 用户信息 */}
                <SidebarUserInfo></SidebarUserInfo>
                {/* 下载app */}
                <DownloadApp></DownloadApp>
                {/* 热门话题 */}
                <SidebarTopicList></SidebarTopicList>

            </div>
        );
    }


    render() {
        let { userList } = this.state
        let isHaveTopicTag = true;  // 话题是否有标签
        return (<div className={styles.wrapper}>

            {this.readerLeft()}
            {this.readerRight()}

        </div>)
    }
}

export default withRouter(TopicThreadListPCPage);
